export default () =>
{	//2017-09-18
	var devices = ['xxs','xs','sm','md','lg'];
	
	var getTestConatiner = function()
	{
		var testContainer = document.querySelector('body>div.bsTestContainer');
		
		if(testContainer === null)
		{
			testContainer = document.createElement('div');
			testContainer.classList.add('bsTestContainer');
			testContainer.style.position = 'absolute';
			testContainer.style.visibility = 'hidden';
			
			devices.forEach(device =>
			{
				const tester = document.createElement('div');
				tester.classList.add('hidden-'+device);
				testContainer.appendChild(tester);
			});
			
			document.querySelector('body').appendChild(testContainer);
		}
		
		return testContainer;
	};
	
	var tc = getTestConatiner();
	
	var detectedDevice = null;
	devices.forEach(device =>
	{
		const element = tc.querySelector('*>div.hidden-'+device)
		
		if(window.getComputedStyle(element).display === 'none') detectedDevice = device;
	});
	
	return detectedDevice;
};